<template>
  <el-breadcrumb
    class="app-levelbar"
    separator="/">
    <el-breadcrumb-item
      v-for="item in levelList"
      :key="item.desc + item.href">
      <a
        :href="item.href"
        class="bread-crumb--a">{{ item.desc }}</a>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
export default {
  data() {
    return {
      levelList: null
    };
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    }
  },
  created() {
    this.getBreadcrumb();
  },
  methods: {
    getBreadcrumb() {
      const breadcrumb = [].concat(this.$route.meta.breadcrumb || []);
      // breadcrumb.unshift({ name: 'Home' })
      this.levelList = breadcrumb.map((item) => {
        const { route, href } = this.$router.resolve(
          Object.assign({}, item),
          { params: this.$route.params },
        );
        return {
          desc: route.meta.desc || route.name,
          href
        };
      });
      this.levelList.push({ desc: this.$route.meta.desc });
    }
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-levelbar.el-breadcrumb {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 10px;
  color:#fff;
}
.bread-crumb--a{
  color:#fff!important;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Levelbar.vue?dcf48b76